/* eslint-disable max-lines-per-function */
import { useCallback } from 'react';

import { getWindowSafe } from '@change-corgi/core/window';
import { useTracking } from '@change-corgi/core-react/tracking';

import type { TipType } from '../../../types';

export function useGetTipActions() {
	const track = useTracking();
	const trackingEventName = 'petition_edit_strength_card_click';
	const currentWindow = getWindowSafe();

	const scrollToBreakPoint = useCallback(
		(breakpoint: string, yOffset: number = -40): void => {
			const el = currentWindow?.document.querySelector(breakpoint);
			if (el) {
				const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
				setTimeout(() => {
					window.scrollTo({ top: y, behavior: 'smooth' });
				}, 100);
			}
		},
		[currentWindow],
	);

	return useCallback(
		(type: TipType) => {
			switch (type) {
				case 'description': {
					return {
						url: '',
						onClick: async () => {
							void track(trackingEventName, { card: 'description' });

							scrollToBreakPoint('#edit_description');
							return Promise.resolve(true);
						},
					};
				}
				case 'media': {
					return {
						url: '',
						onClick: async () => {
							void track(trackingEventName, { card: 'media' });

							scrollToBreakPoint('#add_media');
							return Promise.resolve(true);
						},
					};
				}
				case 'tags': {
					return {
						url: '',
						onClick: async () => {
							void track(trackingEventName, { card: 'tags' });

							scrollToBreakPoint('#edit_topics', 0);
							return Promise.resolve(true);
						},
					};
				}
				case 'decision_maker': {
					return {
						url: '',
						onClick: async () => {
							void track(trackingEventName, { card: 'decision_maker' });

							scrollToBreakPoint('#decision_makers');
							return Promise.resolve(true);
						},
					};
				}
				default:
					return {
						url: undefined,
						onClick: async () => Promise.resolve(true),
					};
			}
		},
		[track, scrollToBreakPoint],
	);
}
